import React, { Component } from 'react'
import { connect } from 'react-redux'
import isEmpty from 'lodash/isEmpty'
import { Button } from 'reactstrap'

import { filterPlants } from '../utilities/helpers'
import {
    getPlantList,
    togglePlantSearch,
    searchPlant,
    changeSearchQuery,
    togglePlantFilter,
    loadPlantList,
    loadPlantSearch
} from '../../actions'
import PlantListItem from '../Plant/PlantListItem'
import SearchHeader from '../Plant/SearchHeader'
import LoadingSpinner from '../Global/LoadingSpinner'
import { FillerDiv, CenteredDiv, DivWithMargin, CenteredDivWithMargin } from '../StyledComponents/Fillers'
import FABButton from '../Global/FABButton'
import FilterView from '../Plant/FilterView'

const loadingComponent = (
    <CenteredDiv>
        <LoadingSpinner /><DivWithMargin bottom="50" important />
    </CenteredDiv>
)

class PlantListPage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            filterOpen: false,
        }

        this.loadNext = this.loadNext.bind(this)
    }

    componentDidMount() {
        const {
            loadList, getList, toggleSearch, page, plantList,
        } = this.props

        if (page === 1 && isEmpty(plantList)) {
            loadList()
            getList(page)
        }

        toggleSearch(false)
        window.scrollTo(0, 0)
    }

    loadNext() {
        const {
            search,
            page,
            loadSearch,
            plantSearch,
            loadList,
            getList,
        } = this.props

        if (search.active && !isEmpty(search.query)) {
            loadSearch()
            plantSearch(search.query, search.page)
        } else {
            loadList()
            getList(page)
        }
    }

    renderSearch() {
        const { search, plantSearch, favoritePlants } = this.props

        const filteredList = filterPlants(search.plants, search.filters, favoritePlants.favorites)
        if (isEmpty(filteredList) && !search.isLoading) {
            return (
                <CenteredDiv>
                    <DivWithMargin bottom="20" important>
                        Keine Pflanzen gefunden...
                    </DivWithMargin>
                    <DivWithMargin bottom="50" important>
                        <Button color="secondary" size="sm" onClick={() => plantSearch('')}>Suche zurücksetzen</Button>
                        <br /><br />
                        <Button color="secondary" size="sm" onClick={() => this.setState({ filterOpen: true })}>Filter anpassen</Button>
                    </DivWithMargin>
                </CenteredDiv>
            )
        }

        return filteredList.map(plant => (
            <PlantListItem plant={plant} key={plant.id} />
        ))
    }

    renderList() {
        const {
            plantList, favoritePlants, search, listIsLoading,
        } = this.props

        const filteredList = filterPlants(plantList, search.filters, favoritePlants.favorites)
        if (isEmpty(filteredList) && !listIsLoading) {
            return (
                <CenteredDiv>
                    <DivWithMargin bottom="20" important>
                        Keine Pflanzen passen zu deinen Filtern...
                    </DivWithMargin>
                    <DivWithMargin bottom="50" important>
                        <Button color="secondary" size="sm" onClick={() => this.setState({ filterOpen: true })}>Filter anpassen</Button>
                    </DivWithMargin>
                </CenteredDiv>
            )
        }

        return filteredList.map(plant => (
            <PlantListItem plant={plant} key={plant.id} />
        ))
    }

    render() {
        const {
            search,
            toggleSearch,
            plantSearch,
            changeQuery,
            toggleFilter,
            isLast,
            listIsLoading,
        } = this.props

        if (this.state.filterOpen) {
            return (<FilterView
                filters={search.filters}
                onClose={() => this.setState({ filterOpen: false })}
                onFilterChange={toggleFilter}
            />)
        }

        const shouldRenderSearch = search.active && !isEmpty(search.query)
        const items = shouldRenderSearch
            ? this.renderSearch()
            : this.renderList()

        const loadingSpinner =
            (shouldRenderSearch && search.isLoading) || (!shouldRenderSearch && listIsLoading)
                ? loadingComponent
                : null

        const loadMore =
            (shouldRenderSearch && (search.isLoading || search.isLast))
            || (!shouldRenderSearch && (isLast || listIsLoading))
            || (items.type && items.type.name === 'StyledComponent')
                ? null
                : (
                    <CenteredDivWithMargin top="20" bottom="20" important>
                        <Button color="info" size="sm" onClick={() => this.loadNext()}>Mehr laden</Button>
                    </CenteredDivWithMargin>
                )

        return (
            <FillerDiv>
                <SearchHeader
                    searchQuery={search.query}
                    searchActive={search.active}
                    onSearchTrigger={plantSearch}
                    onSearchQueryChange={changeQuery}
                    onSearchClose={() => toggleSearch(false)}
                />
                {items}
                {loadingSpinner}
                {loadMore}
                <FABButton
                    items={['search', 'visual-recognititon', 'filter']}
                    onSearchClicked={() => toggleSearch(true)}
                    onFilterClicked={() => this.setState({ filterOpen: true })}
                />
            </FillerDiv>
        )
    }
}

const mapStateToProps = state => ({
    plantList: state.plantList.plants,
    isLast: state.plantList.isLast,
    page: state.plantList.page,
    listIsLoading: state.plantList.isLoading,
    search: state.search,
    favoritePlants: state.favoritePlants,
})


export default connect(mapStateToProps, {
    getList: getPlantList,
    loadList: loadPlantList,
    loadSearch: loadPlantSearch,
    toggleSearch: togglePlantSearch,
    toggleFilter: togglePlantFilter,
    plantSearch: searchPlant,
    changeQuery: changeSearchQuery,
})(PlantListPage)



// WEBPACK FOOTER //
// ./src/components/pages/PlantList.js